// Sibling imports
const requireBridge = require('./shim')

function showAddUrlModal() {
  /**
   * @TODO Port wiggin add-url-modal to React
   * @see https://app.asana.com/0/0/1131079329757886/f
   */
  const AddUrlModal = require('client/components/add-url-modal')
  return AddUrlModal.promise()
}

function showMixEditModal(options) {
  const MixEditModal = require('client/components/mix-edit-modal')
  const {
    collectionDeleted,
    collectionEdited
  } = require('client-v2/common/models/collection/actions')
  return MixEditModal.promise(options)
  .then(result => {
    if (result.deleted) {
      app.store.dispatch(collectionDeleted(result.id))
    } else {
      app.store.dispatch(collectionEdited(result))
    }
  })
}

function showUserActionsModal(options) {
  const UserActionsModal = require('client/components/user-actions-modal')
  return UserActionsModal.confirmUserAction(options)
}

module.exports = {
  showAddUrlModal: requireBridge(showAddUrlModal),
  showMixEditModal: requireBridge(showMixEditModal),
  showUserActionsModal: requireBridge(showUserActionsModal)
}
